import React from 'react';
export function AIBotPoliticsPage() {
  return <div className="min-h-screen bg-black text-white selection:bg-cyan-500/30 selection:text-cyan-200 font-sans" data-id="element-961">
      <div className="max-w-2xl mx-auto px-6 py-16" data-id="element-962">
        <h1 className="text-2xl md:text-3xl text-white mb-10" style={{
        fontFamily: 'Space Grotesk, sans-serif',
        fontWeight: 400
      }} data-id="element-963">
          Política de Privacidad – AI ChatBot
        </h1>

        <p className="text-gray-300 mb-8 leading-relaxed" data-id="element-964">
          Esta aplicación utiliza la API oficial de WhatsApp Business (Meta)
          para enviar y recibir mensajes.
        </p>

        <section className="mb-8" data-id="element-965">
          <h2 className="text-lg text-white mb-3" style={{
          fontFamily: 'Space Grotesk, sans-serif',
          fontWeight: 500
        }} data-id="element-966">
            Datos que se recopilan
          </h2>
          <ul className="text-gray-400 space-y-2 list-disc list-inside" data-id="element-967">
            <li data-id="element-968">Número de teléfono del usuario</li>
            <li data-id="element-969">Contenido de los mensajes enviados al bot</li>
          </ul>
        </section>

        <section className="mb-8" data-id="element-970">
          <h2 className="text-lg text-white mb-3" style={{
          fontFamily: 'Space Grotesk, sans-serif',
          fontWeight: 500
        }} data-id="element-971">
            Uso de los datos
          </h2>
          <ul className="text-gray-400 space-y-2 list-disc list-inside" data-id="element-972">
            <li data-id="element-973">
              Los datos se utilizan únicamente para responder mensajes y brindar
              el servicio solicitado.
            </li>
            <li data-id="element-974">No se venden, comparten ni ceden datos a terceros.</li>
          </ul>
        </section>

        <section className="mb-8" data-id="element-975">
          <h2 className="text-lg text-white mb-3" style={{
          fontFamily: 'Space Grotesk, sans-serif',
          fontWeight: 500
        }} data-id="element-976">
            Almacenamiento
          </h2>
          <ul className="text-gray-400 space-y-2 list-disc list-inside" data-id="element-977">
            <li data-id="element-978">
              Los mensajes pueden ser procesados de forma temporal para generar
              respuestas.
            </li>
            <li data-id="element-979">
              No se realiza almacenamiento permanente de conversaciones, salvo
              para fines técnicos.
            </li>
          </ul>
        </section>

        <section className="mb-8" data-id="element-980">
          <h2 className="text-lg text-white mb-3" style={{
          fontFamily: 'Space Grotesk, sans-serif',
          fontWeight: 500
        }} data-id="element-981">
            Contacto
          </h2>
          <p className="text-gray-400 leading-relaxed" data-id="element-982">
            El uso del servicio implica la aceptación de esta política.
          </p>
        </section>
      </div>
    </div>;
}